/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../_metronic/helpers'
import 'rc-slider/assets/index.css'
import {useDispatch, useSelector} from 'react-redux'
import {GeneralDataOFLoginUser} from '../Utils/Auth'
import Promocodepopup from '../pages/Common/modal/Promocodepopup'
import SmsMmsPopup from '../pages/Common/modal/SmsMmsPopup'
import {GetProductList} from '../Redux/AdminPanel/PurchaseCreditSlice'
import {FeGetPriceRuleList} from '../pages/AdminPages/Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'
import {Elements} from '@stripe/react-stripe-js'
import CardPaymentPopup from '../pages/Common/modal/CardPaymentPopup'
import PriceViewPopup from '../pages/Common/modal/PriceViewPopup'
import {ENV} from '../Utils/_helpers/EnvHelper'
import StripeJSProvider from '../Utils/StripeJSProvider'
import {CreditOption} from '../pages/Common/CreditSelection'
import {PriceRate} from '../types'
import {formatCreditAmount} from '../Utils/_helpers/number'
import {CampType} from '../../services/cellcast.v2.types'
import {CouponRate} from '../../services/cellcast.type'
import {usePricingRulesMutation} from '../../services/cellcast.v3'
import {
  useAdminGetGlobalSettingQuery,
  useLazyGetDefaultCouponRateQuery,
} from '../../services/cellcast'
import {PaymentPricingRules} from '../../services/cellcast.v3.types'
import {
  getAllUserDetails,
  getIsDefaultRegion,
} from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'

export const MINIMUM_CREDIT = 20
export const getMinimumCredit = (credit: number) => {
  if (credit <= MINIMUM_CREDIT) {
    return MINIMUM_CREDIT
  }
  return credit
}
const PurchasePopup = ({
  show,
  handleClose,
  purchaseModelData,
  purpose = 'send the campaign',
}: any) => {
  const [smsdetailpopup, setsmsdetailpopup] = useState(false)
  const maxCredit = 500000
  const minCredit = 20
  const dispatch = useDispatch()
  const accountId = GeneralDataOFLoginUser()?.user?.accountId
  const defaultCoupon = GeneralDataOFLoginUser()?.user?.defaulCoupon
  const userDetail = useSelector(getAllUserDetails)
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const credits = useSelector((state: any) => state?.userDetails?.userDetails?.data)
  const purchaseCreditInputref: any = useRef()
  const [card, setCard] = useState(false)
  const [noOfCredit, setNoOFCredit] = useState<any>(0)
  const [quickSms, setQuickSms] = useState(purchaseModelData?.type || 'sms')
  const [checkBox, setCheckBox] = useState(false)
  const [viewPricePopup, setViewPricePopup] = useState(false)
  const [price, setPrice] = useState(0)
  const [discount, setDiscount] = useState<any>(0)
  const [couponId, setCouponId] = useState('')
  const [error, setError] = useState('')
  const [leastPrice, setleastPrice] = useState<any>(20)
  const [showContactInfo, setShowContactInfo] = useState<any>(false)
  const userData: any = GeneralDataOFLoginUser()?.globalSettingData?.[0]?.value
  const [promocodePopup, setPromocodePopup] = useState<any>(false)
  const [selectedOption, setSelectedOption] = useState<number>(0)

  const {data} = useAdminGetGlobalSettingQuery(null)
  const globalSetting = (data?.data || []).find((item) => item?.name === 'GLOBAL_SETTING')

  // Calculate additional credits needed (required - current)
  const additionalCreditsNeeded = useMemo(() => {
    const requiredCredits = purchaseModelData?.minimum || 0
    const currentCredit = credits?.credits?.[purchaseModelData?.type] || 0
    const additional = requiredCredits - currentCredit
    return additional > 0 ? Math.ceil(additional) : 0
  }, [purchaseModelData?.minimum, purchaseModelData?.type, credits])

  const [minCouponCredit, setMinCouponCredit] = useState<any>(0)
  const [couponFlatRate, setCouponFlatRate] = useState<any>(0)
  const [flatRate, setFlatRate] = useState<any>(0)
  const [freeCredit, setFreeCredit] = useState<any>(0)
  const [couponCode, setCouponCode] = useState<any>('')
  const [discountPercentage, setPercentage] = useState<any>(0)
  const [couponData, setCouponData] = useState<any>(null)
  const [manualCouponData, setManualCouponData] = useState<any>(null)
  const [defaultCouponRate, setDefaultCouponRate] = useState<CouponRate[]>([])
  const ApplyPromoCode = useMemo(
    () => (
      <Promocodepopup
        setDiscount={setDiscount}
        setPercentage={setPercentage}
        setCouponId={setCouponId}
        setFlatRate={setFlatRate}
        setMinCouponCredit={setMinCouponCredit}
        setCouponFlatRate={setCouponFlatRate}
        checkBox={checkBox}
        quickSms={quickSms}
        price={price}
        noOfCredit={noOfCredit}
        show={promocodePopup}
        handleClose={() => setPromocodePopup(false)}
        setFreeCredit={setFreeCredit}
        setCouponCode={setCouponCode}
        setManualCouponData={setManualCouponData}
      />
    ),
    [promocodePopup]
  )

  const restAllData = () => {
    setDiscount(0)
    setFlatRate(0)
    setCheckBox(false)
    setCard(false)
    setCouponId('')
    setPrice(0)
    setNoOFCredit(0)
    setCouponCode('')
    setFreeCredit(0)
    setPercentage(0)
    setSelectedOption(0)
  }
  const handleChange = (event: any) => {
    if (!isNaN(event)) {
      setFlatRate(0)
      setNoOFCredit(event.trim())
    }
  }
  const handleNumberConvert = (val: any) => {
    const data: any = new Intl.NumberFormat('en-US').format(val)
    return data
  }
  const handleError = (value: any) => {
    const minCredits =
      quickSms == 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)

    if (isNaN(+value)) {
      setError('Credit must be Integer')
      return
    }
    if (!(+value <= +maxCredit)) {
      setError(`Credit should be less than max ${maxCredit}`)
      return
    }
    if (!(+value >= +minCredits)) {
      setError(
        `Credit must be greater than ${
          quickSms == 'sms'
            ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
            : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)
        }`
      )
      return
    }
    if (value <= maxCredit && value >= minCredits) {
      setError('')
      return
    }
  }

  const ApplysmsPopup = useMemo(
    () => <SmsMmsPopup show={smsdetailpopup} handleClose={() => setsmsdetailpopup(false)} />,
    [smsdetailpopup]
  )

  const [pricingRules, {data: RateCardList}] = usePricingRulesMutation()
  const [fetchDefaultCouponRate] = useLazyGetDefaultCouponRateQuery()

  const getPricingRules = () => {
    if (isDefaultRegion) {
      dispatch(FeGetPriceRuleList({accountId: accountId}))
      return
    }

    pricingRules({
      action: 'find_pricing_rules',
      data: {
        accountId: accountId,
      },
    })
  }

  useEffect(() => {
    dispatch(GetProductList())
    dispatch(FeGetPriceRuleList({accountId: accountId}))

    getPricingRules()
    purchaseCreditInputref?.current?.focus()
  }, [])

  useEffect(() => {
    if (defaultCoupon !== '') {
      fetchDefaultCouponRate(null).then((res) => {
        if (res.data && Array.isArray(res.data.data)) {
          setDefaultCouponRate(res.data.data)
        }
      })
    }
  }, [defaultCoupon, fetchDefaultCouponRate])

  const defaultRegionPriceData = useSelector((state: any) => state?.priceRules?.RateCardList)

  const defaultRegionPriceListSMS = Array.isArray(defaultRegionPriceData)
    ? defaultRegionPriceData.filter((key: any) => key?.type === 'SMS')
    : []

  const defaultRegionPriceListMMS = Array.isArray(defaultRegionPriceData)
    ? defaultRegionPriceData.filter((key: any) => key?.type === 'MMS')
    : []

  const otherRegionPriceData = RateCardList?.data

  const otherRegionPriceListSMS = Array.isArray(otherRegionPriceData)
    ? otherRegionPriceData.filter(
        (key: PaymentPricingRules) => key?.Type === CampType.sms.toUpperCase()
      )
    : []

  const otherRegionPriceListMMS = Array.isArray(otherRegionPriceData)
    ? otherRegionPriceData.filter(
        (key: PaymentPricingRules) => key?.Type === CampType.mms.toUpperCase()
      )
    : []

  const PriceRateListSMS = isDefaultRegion ? defaultRegionPriceListSMS : otherRegionPriceListSMS
  const PriceRateListMMS = isDefaultRegion ? defaultRegionPriceListMMS : otherRegionPriceListMMS

  useEffect(() => {
    /** Other Region */
    if (!isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let leastRate = PriceRateListSMS?.find(
          (key: PaymentPricingRules) =>
            key?.CreditEndRange >= +minCredit && key?.CreditStartRange <= +minCredit
        )?.FinalPrice
        setleastPrice(leastRate)
      } else {
        let leastRate = PriceRateListMMS?.find(
          (key: PaymentPricingRules) =>
            key?.CreditEndRange >= +minCredit && key?.CreditStartRange <= +minCredit
        )?.FinalPrice
        setleastPrice(leastRate)
      }
    }
  }, [quickSms, minCredit])

  useEffect(() => {
    /** Default Region */
    if (isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let leastRate = PriceRateListSMS?.find(
          (key: any) => key?.creditendrange >= +minCredit && key?.creditstartrange <= +minCredit
        )?.finalPrice
        setleastPrice(leastRate)
      } else {
        let leastRate = PriceRateListMMS?.find(
          (key: any) => key?.creditendrange >= +minCredit && key?.creditstartrange <= +minCredit
        )?.finalPrice
        setleastPrice(leastRate)
      }
    }
  }, [quickSms, minCredit])

  useEffect(() => {
    /** Other region */
    if (!isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let price =
          PriceRateListSMS?.find(
            (key: PaymentPricingRules) =>
              key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
          ) === undefined
            ? PriceRateListSMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange ===
                  (PriceRateListSMS.length > 0
                    ? Math.max(
                        ...PriceRateListSMS.map((o: PaymentPricingRules) => o?.CreditEndRange)
                      )
                    : 0)
              )?.FinalPrice
            : PriceRateListSMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
              )?.FinalPrice
        setPrice(price as number)
      } else {
        let price =
          PriceRateListMMS?.find(
            (key: PaymentPricingRules) =>
              key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
          ) === undefined
            ? PriceRateListMMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange ===
                  (PriceRateListMMS.length > 0
                    ? Math.max(
                        ...PriceRateListMMS.map((o: PaymentPricingRules) => o?.CreditEndRange)
                      )
                    : 0)
              )?.FinalPrice
            : PriceRateListMMS?.find(
                (key: PaymentPricingRules) =>
                  key?.CreditEndRange >= +noOfCredit && key?.CreditStartRange <= +noOfCredit
              )?.FinalPrice
        setPrice(price as number)
      }

      if (noOfCredit > 500000) {
        setShowContactInfo(true)
      } else {
        setShowContactInfo(false)
      }
    }
  }, [quickSms, noOfCredit, PriceRateListSMS, PriceRateListMMS])

  useEffect(() => {
    /** Default region */
    if (isDefaultRegion) {
      if (quickSms === CampType.sms) {
        let price =
          PriceRateListSMS?.find(
            (key: any) => key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
          ) === undefined
            ? PriceRateListSMS?.find(
                (key: any) =>
                  key?.creditendrange ===
                  (PriceRateListSMS.length > 0
                    ? Math.max(...PriceRateListSMS.map((o: any) => o?.creditendrange))
                    : 0)
              )?.finalPrice
            : PriceRateListSMS?.find(
                (key: any) =>
                  key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
              )?.finalPrice
        setPrice(price as number)
      } else {
        let price =
          PriceRateListMMS?.find(
            (key: any) => key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
          ) === undefined
            ? PriceRateListMMS?.find(
                (key: any) =>
                  key?.creditendrange ===
                  (PriceRateListMMS.length > 0
                    ? Math.max(...PriceRateListMMS.map((o: any) => o?.creditendrange))
                    : 0)
              )?.finalPrice
            : PriceRateListMMS?.find(
                (key: any) =>
                  key?.creditendrange >= +noOfCredit && key?.creditstartrange <= +noOfCredit
              )?.finalPrice
        setPrice(price as number)
      }

      if (noOfCredit > 500000) {
        setShowContactInfo(true)
      } else {
        setShowContactInfo(false)
      }
    }
  }, [quickSms, noOfCredit, PriceRateListSMS, PriceRateListMMS])

  useEffect(() => {
    const minCredits =
      purchaseModelData?.type === 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)

    if (additionalCreditsNeeded > 0) {
      const creditToSet =
        additionalCreditsNeeded > minCredits ? additionalCreditsNeeded : minCredits
      setNoOFCredit(creditToSet)
      setSelectedOption(creditToSet)
    } else if (purchaseModelData?.purchaseCredit) {
      const creditToSet =
        purchaseModelData.purchaseCredit > minCredits
          ? purchaseModelData.purchaseCredit
          : minCredits
      setNoOFCredit(creditToSet)
      setSelectedOption(creditToSet)
    } else if (selectedOption > 0) {
      // Keep previous selection if no new purchase data
      setNoOFCredit(selectedOption)
    }
    setQuickSms(purchaseModelData?.type || 'sms')
  }, [purchaseModelData, additionalCreditsNeeded, userData])

  const setDefaultCoupon = (metadata: any) => {
    if (metadata?.flat_rate && metadata?.discount_type === 'fixed_price') {
      setFlatRate(+metadata?.flat_rate)
      setDiscount(0)
      setCouponFlatRate(+metadata?.flat_rate)
      setFreeCredit(0)
      setPercentage(0)
      setCouponCode(metadata?.code)
      setCouponId(metadata?.id)
    }

    if (metadata?.discount_type === 'percentage') {
      const discount = parseInt(metadata?.percentage_off ?? 0, 10)
      setDiscount(0)
      setFlatRate(0)
      setCouponFlatRate(0)
      setFreeCredit(0)
      setPercentage(discount)
      setCouponCode(metadata?.code)
      setCouponId(metadata?.id)
    }

    if (metadata?.discount_type === 'free_credit') {
      const freeCredit = parseInt(metadata?.free_credit ?? 0, 10)
      setDiscount(0)
      setFlatRate(0)
      setCouponFlatRate(0)
      setFreeCredit(freeCredit)
      setPercentage(0)
      setCouponCode(metadata?.code)
      setCouponId(metadata?.id)
    }
  }

  useEffect(() => {
    /** Default region */
    if (isDefaultRegion) {
      // handle coupon with minimum credit
      if (couponId !== '' && minCouponCredit > 0) {
        if (noOfCredit >= minCouponCredit) {
          setFlatRate(couponFlatRate)
        } else {
          setFlatRate(0)
        }
      }
    }
  }, [couponId, minCouponCredit, noOfCredit, couponFlatRate, isDefaultRegion])

  useEffect(() => {
    if (!isDefaultRegion) return
    if (userDetail?.hasUsedCoupon) return
    if (defaultCouponRate.length === 0) return

    // apply default coupon
    const match = defaultCouponRate.find((r) => {
      if (+r.min_credit > 0 && +r.max_credit > 0) {
        return noOfCredit >= +r.min_credit && noOfCredit <= +r.max_credit
      } else if (+r.min_credit > 0 && +r.max_credit === 0) {
        return noOfCredit >= +r.min_credit
      } else if (+r.min_credit === 0 && +r.max_credit > 0) {
        return noOfCredit <= +r.max_credit
      }
      return false
    })

    if (match) {
      setDefaultCoupon(match)
    } else {
      setDiscount(0)
      setFlatRate(0)
      setCouponFlatRate(0)
      setFreeCredit(0)
      setPercentage(0)
      setCouponCode('')
      setCouponId('')
      setManualCouponData(null)
    }
  }, [defaultCouponRate, noOfCredit])

  useEffect(() => {
    const minCredit = parseInt(manualCouponData?.min_credit ?? '0', 10)
    const maxCredit = parseInt(manualCouponData?.max_credit ?? '0', 10)
    const withinMin = !minCredit || noOfCredit >= minCredit
    const withinMax = !maxCredit || noOfCredit <= maxCredit
    const isEligible = withinMin && withinMax

    if (defaultCouponRate?.length === 0 && !isEligible) {
      setDiscount(0)
      setFlatRate(0)
      setCouponFlatRate(0)
      setFreeCredit(0)
      setPercentage(0)
      setCouponCode('')
      setCouponId('')
      setManualCouponData(null)
    }
  }, [noOfCredit])

  useEffect(() => {
    if (defaultCouponRate?.length === 0) return

    setCouponData(defaultCouponRate[defaultCouponRate?.length - 1])
  }, [defaultCouponRate])

  const viewPriceModel = useMemo(
    () => <PriceViewPopup show={viewPricePopup} handleClose={() => setViewPricePopup(false)} />,
    [viewPricePopup]
  )

  const creditOptions = useMemo<CreditOption[]>(() => {
    const smsRates: PriceRate[] = PriceRateListSMS || []
    const mmsRates: PriceRate[] = PriceRateListMMS || []

    const calculateDiscount = (actualPrice: number, finalPrice: number) => {
      return actualPrice > finalPrice ? `${((1 - finalPrice / actualPrice) * 100).toFixed(0)}%` : ''
    }

    const minCredits =
      quickSms === 'sms'
        ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
        : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)

    const findPrice = (amount: number, rates: PriceRate[]) => {
      const rate = rates.find((r) => amount >= r.creditstartrange && amount <= r.creditendrange)
      return rate ? rate.finalPrice : 0
    }

    const smsRateForMinCredit = smsRates.find(
      (r) => minCredits >= r.creditstartrange && minCredits <= r.creditendrange
    )
    const mmsRateForMinCredit = mmsRates.find(
      (r) => minCredits >= r.creditstartrange && minCredits <= r.creditendrange
    )

    if (!smsRateForMinCredit || !mmsRateForMinCredit) {
      return []
    }

    const minCreditOption: CreditOption = {
      amount: minCredits,
      price: {
        sms: `$${findPrice(minCredits, smsRates).toFixed(3)}`,
        mms: `$${findPrice(minCredits, mmsRates).toFixed(2)}`,
      },
      discountPercentage: {
        sms: calculateDiscount(leastPrice, smsRateForMinCredit.finalPrice),
        mms: calculateDiscount(leastPrice, mmsRateForMinCredit.finalPrice),
      },
    }

    const validSmsRates = smsRates?.filter((rate) => rate.creditendrange >= minCredits)
    const validMmsRates = mmsRates?.filter((rate) => rate.creditendrange >= minCredits)
    const sortedSmsRates = validSmsRates?.sort((a, b) => a.creditstartrange - b.creditstartrange)
    const sortedMmsRates = validMmsRates?.sort((a, b) => a.creditstartrange - b.creditstartrange)

    const optionsFromRates = sortedSmsRates?.map((smsOption) => {
      const matchingMMS = sortedMmsRates.find(
        (mmsOption) => mmsOption.creditstartrange === smsOption.creditstartrange
      )

      const smsDiscount = calculateDiscount(leastPrice, smsOption.finalPrice)
      const mmsDiscount = matchingMMS ? calculateDiscount(leastPrice, matchingMMS.finalPrice) : ''

      return {
        amount: smsOption.creditstartrange,
        price: {
          sms: `$${smsOption.finalPrice.toFixed(3)}`,
          mms: matchingMMS ? `$${matchingMMS.finalPrice.toFixed(2)}` : '$0.000',
        },
        discountPercentage: {
          sms: smsDiscount,
          mms: mmsDiscount,
        },
      }
    })

    return [minCreditOption, ...optionsFromRates]
  }, [PriceRateListSMS, PriceRateListMMS, quickSms, leastPrice, isDefaultRegion, userData])

  const handleResetDiscount = () => {
    if (discount !== 0) setDiscount(0)
    if (flatRate !== 0) setFlatRate(0)
  }

  const handleCreditOptionClick = (amount: number) => {
    handleError(amount.toString())
    handleResetDiscount()
    setSelectedOption(amount)
    setNoOFCredit(amount)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value.replace(/,/g, '')
    const numericVal = Number(val)

    handleError(val)
    handleResetDiscount()
    setNoOFCredit(numericVal)

    const matchedOption = creditOptions.find((option, index) => {
      const nextOption = creditOptions[index + 1]
      return (
        numericVal >= option.amount &&
        (!nextOption || numericVal < nextOption.amount || numericVal < 250)
      )
    })

    setSelectedOption(matchedOption?.amount || 0)
  }

  useEffect(() => {
    if (noOfCredit === 0 || error) {
      setSelectedOption(0)
    }
  }, [noOfCredit, error])

  let discountedPrice = price * (1 - discount / 100)
  let unitPrice = price

  if (flatRate) {
    unitPrice = flatRate?.toFixed(3)
  }

  if (discount > 0) {
    unitPrice = +discountedPrice
  }

  const calculateTotalPrice = ({
    credit,
    unitPrice,
    freeCredit,
    flatRate,
    discountPercentage,
  }: {
    credit: number
    unitPrice: number
    freeCredit?: number
    flatRate?: number
    discountPercentage?: number
  }) => {
    // reduce credits first if freeCredit coupon exists
    const effectiveCredit = Math.max(0, credit - (freeCredit ?? 0))
    let subtotal = effectiveCredit * +unitPrice
    if (flatRate) {
      subtotal = effectiveCredit * +flatRate
    }

    let discountAmount = 0
    if (discountPercentage) {
      discountAmount = (subtotal * discountPercentage) / 100
    }

    const totalPrice = Math.max(0, subtotal - discountAmount)
    return totalPrice
  }

  const credit = +noOfCredit
  const subTotal = calculateTotalPrice({
    credit: credit,
    unitPrice: +unitPrice,
    freeCredit: freeCredit,
    flatRate: flatRate,
    discountPercentage: discountPercentage,
  })

  const getCouponValue = () => {
    let value = ''
    if (freeCredit) {
      value = `${freeCredit} Credit`
    } else if (flatRate) {
      value = flatRate
    } else if (discountPercentage) {
      value = `${discountPercentage}%`
    }

    return value
  }

  const handleCalculateDiscount = (initialDiscount: number) => {
    const calculatedDiscount = (leastPrice ?? +unitPrice) * Number(noOfCredit) - subTotal
    return initialDiscount + calculatedDiscount
  }

  const handleCalculateDiscountPercentage = (initialDiscount?: number, creditAmount?: number) => {
    let amount = creditAmount ? creditAmount : noOfCredit
    const subTotalRef = amount * +leastPrice
    const calculatedDiscount = handleCalculateDiscount(initialDiscount || 0)
    return (((initialDiscount || 0) + calculatedDiscount) / subTotalRef) * 100
  }

  // Filter credit options for display
  const filteredCreditOptions = creditOptions?.filter(
    (option) =>
      option.amount >=
        (quickSms === 'sms'
          ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
          : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)) &&
      option.amount <= maxCredit &&
      option.amount !== 112 &&
      option.amount !== 3000
  )

  const additionalFee = useMemo(() => {
    if (!globalSetting || !(globalSetting as any).value) return {percentage: 0, amount: 0}

    const isAdditionalFeeEnabled = (globalSetting as any).value['ENABLE_ADDITIONAL_FEE']

    let fee = {percentage: 0, amount: 0}

    if (isAdditionalFeeEnabled) {
      const totalPurchaseAmount = +subTotal * 1.1
      const minimumPurchaseAmmount = parseFloat(
        (globalSetting as any).value['MINIMUM_PURCHASE_AMOUNT'] || 0
      )

      if (+totalPurchaseAmount >= +minimumPurchaseAmmount) {
        const percentage = parseFloat(
          (globalSetting as any).value['ADDITIONAL_FEE_PERCENTAGE'] || 0
        )
        fee = {
          percentage,
          amount: (+totalPurchaseAmount * percentage) / 100,
        }
      }
    }

    return fee
  }, [globalSetting, subTotal])

  return (
    <>
      {ApplyPromoCode}
      {ApplysmsPopup}
      {viewPriceModel}
      <Modal
        onHide={() => {
          handleClose()
        }}
        id='kt_modal_create_app_'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-1000px h-auto'
        show={show}
      >
        <div className='container-xxl p-0'>
          <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
            <h5 className='fw-bold m-0'>Buy Credits</h5>
            <div className='d-flex ms-2'>
              {/*begin::Close*/}
              <div
                className='btn btn-icon btn-sm btn-light-primary ms-2'
                data-bs-dismiss='modal'
                onClick={handleClose}
              >
                <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
              </div>
              {/*end::Close*/}
            </div>
          </div>
          <div className='modal-body'>
            <div
              className='card select-credit'
              style={{
                margin: 0,
              }}
            >
              <div className='row m-0'>
                <div className='col-lg-7 py-5 px-10 pb-10 padding-remove'>
                  <div className='card-header border-0 my-3 mb-8 p-0'>
                    <div className='card-title align-items-start flex-column mb-1'>
                      <span className='card-label fw-bolder fs-4'>
                        An additional {additionalCreditsNeeded} credits is required to {purpose}
                      </span>
                    </div>
                    <p className='text-muted'>
                      Please an SMS or MMS bundle to The more you buy the CHEAPER the credits gets,
                      and they never expire! If you still need more info,{' '}
                      <a
                        onClick={() => setViewPricePopup(true)}
                        className='text-underline cursor-pointer'
                      >
                        visit our full pricing table
                      </a>
                    </p>
                  </div>

                  <div className='credit-purchase'>
                    <h5 className='mb-5'>
                      What type of credits would you like to purchase?{' '}
                      <a href='#' onClick={() => setsmsdetailpopup(true)} className='ms-1'>
                        <svg
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            opacity='0.3'
                            d='M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z'
                            fill='#838492'
                          />
                          <path
                            d='M8 10.2497C7.85081 10.2497 7.70774 10.1904 7.60225 10.0849C7.49676 9.97945 7.4375 9.83638 7.4375 9.68719V9.07219C7.4305 8.69625 7.52949 8.32593 7.72314 8.00362C7.9168 7.68131 8.19728 7.42003 8.5325 7.24969C8.72899 7.15461 8.89643 7.00865 9.01744 6.82698C9.13845 6.64531 9.20862 6.43455 9.22064 6.2166C9.23266 5.99864 9.18611 5.78144 9.08581 5.58756C8.98552 5.39368 8.83514 5.23019 8.6503 5.11408C8.46546 4.99796 8.25291 4.93345 8.03471 4.92725C7.81651 4.92106 7.60063 4.97339 7.4095 5.07883C7.21837 5.18427 7.05895 5.33895 6.94781 5.52683C6.83667 5.7147 6.77787 5.92891 6.7775 6.14719C6.7775 6.29638 6.71823 6.43945 6.61274 6.54494C6.50726 6.65043 6.36418 6.70969 6.215 6.70969C6.06581 6.70969 5.92274 6.65043 5.81725 6.54494C5.71176 6.43945 5.6525 6.29638 5.6525 6.14719C5.65375 5.80373 5.73012 5.46469 5.87624 5.15386C6.02237 4.84303 6.23472 4.56792 6.4984 4.34783C6.76208 4.12773 7.07072 3.96798 7.40267 3.87977C7.73461 3.79156 8.08184 3.77703 8.42 3.83719C8.89211 3.92601 9.32594 4.15664 9.66361 4.49834C10.0013 4.84004 10.2268 5.27656 10.31 5.74969C10.4046 6.25535 10.3294 6.7781 10.0961 7.23658C9.8628 7.69506 9.48447 8.06355 9.02 8.28469C8.87783 8.36211 8.75985 8.47735 8.6791 8.61766C8.59836 8.75796 8.558 8.91787 8.5625 9.07969V9.69469C8.56052 9.84257 8.50039 9.98373 8.39512 10.0876C8.28984 10.1915 8.14789 10.2497 8 10.2497Z'
                            fill='#838492'
                          />
                          <path
                            d='M7.99999 12.1924C8.31065 12.1924 8.56249 11.9405 8.56249 11.6299C8.56249 11.3192 8.31065 11.0674 7.99999 11.0674C7.68933 11.0674 7.43749 11.3192 7.43749 11.6299C7.43749 11.9405 7.68933 12.1924 7.99999 12.1924Z'
                            fill='#7950F2'
                          />
                        </svg>
                      </a>
                    </h5>

                    <ul className='nav nav-tabs'>
                      <li className='nav-item me-3 mb-3'>
                        <button
                          className={`nav-link btn btn-outline btn-outline-dashed btn-outline-green w-100 p-4 px-6 ${quickSms ===
                            'sms' && 'active'}`}
                          onClick={(e: any) => {
                            setError('')
                            if (discount !== 0) {
                              setQuickSms('sms')
                              setDiscount(0)
                            } else {
                              setQuickSms('sms')
                            }
                          }}
                        >
                          SMS
                        </button>
                      </li>
                      <li className='nav-item me-3 mb-3'>
                        <button
                          className={`nav-link btn btn-outline btn-outline-dashed btn-outline-blue w-100 p-4 px-6 ${!(
                            quickSms === 'sms'
                          ) && 'active'}`}
                          onClick={(e: any) => {
                            setError('')
                            if (discount !== 0) {
                              setQuickSms('mms')
                              setDiscount(0)
                            } else {
                              setQuickSms('mms')
                            }
                          }}
                        >
                          MMS
                        </button>
                      </li>
                    </ul>

                    <div className='tab-content' id='myTabContent'>
                      <div
                        className='tab-pane fade active show'
                        id='Now'
                        role='tabpanel'
                        aria-labelledby='Now-tab'
                      >
                        <h5 className='mb-4 text-start'>
                          Select how many credits you want or type the amount
                        </h5>
                        <div
                          className='d-grid mb-4'
                          style={{
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            marginRight: '180px',
                            gap: '14px',
                          }}
                        >
                          {filteredCreditOptions.map((option) => {
                            const discount = option.discountPercentage[quickSms as 'sms' | 'mms']
                            return (
                              <button
                                key={option.amount}
                                className={`btn btn-outline btn-outline-dashed btn-outline-default position-relative ${selectedOption ===
                                  option.amount && 'active'}`}
                                style={{
                                  borderRadius: '8px',
                                  paddingTop: '10px',
                                  paddingBottom: '10px',
                                }}
                                onClick={() => handleCreditOptionClick(option.amount)}
                              >
                                {discount && option.amount === 100000 && (
                                  <span
                                    className='fw-boldest position-absolute top-0 translate-middle badge bg-primary text-white rounded-3'
                                    style={{left: '76%'}}
                                  >
                                    Save {discount}
                                  </span>
                                )}
                                <label
                                  style={{
                                    fontWeight: 700,
                                    fontSize: '14px',
                                  }}
                                >
                                  {formatCreditAmount(option.amount)}
                                </label>
                                <p
                                  style={{
                                    fontWeight: 500,
                                    fontSize: '10px',
                                    marginBottom: '0px',
                                  }}
                                >
                                  1 {quickSms.toUpperCase()} ={' '}
                                  {option.price[quickSms as 'sms' | 'mms']}
                                </p>
                              </button>
                            )
                          })}
                        </div>

                        <div className='tab-content' id='myTabContent' style={{marginTop: '24px'}}>
                          <div
                            className='tab-pane fade active show'
                            id='Now'
                            role='tabpanel'
                            aria-labelledby='Now-tab'
                          >
                            <div className='d-flex flex-column'>
                              <h5>Your Credit</h5>
                              <div className='credit-box'>
                                <div className='box-inner'>
                                  <input
                                    ref={purchaseCreditInputref}
                                    maxLength={maxCredit.toString().length + 1}
                                    type='text'
                                    value={new Intl.NumberFormat('en-US').format(noOfCredit)}
                                    onChange={handleInputChange}
                                  />
                                  {error && <span className='text-danger'>{error}</span>}
                                  <p>
                                    1 credit = 1 Message ({quickSms === 'sms' ? 165 : 1000}{' '}
                                    characters). Credit never expire
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* {sliderShow} */}

                        {/* <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input me-5'
                      id='stagger'
                      type='checkbox'
                      checked={checkBox}
                      onChange={(e: any) => {
                        if (discount !== 0) {
                          setCheckBox(!checkBox)
                          setDiscount(0)
                        } else {
                          setCheckBox(!checkBox)
                        }
                      }}
                    />
                    <div>
                      <label htmlFor='stagger'>
                        I will send with my Business name or my number (+30% )
                        <a href='#' className='ms-2'>
                          <svg
                            width='16'
                            height='16'
                            viewBox='0 0 16 16'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              opacity='0.3'
                              d='M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z'
                              fill='#838492'
                            />
                            <path
                              d='M8 10.2497C7.85081 10.2497 7.70774 10.1904 7.60225 10.0849C7.49676 9.97945 7.4375 9.83638 7.4375 9.68719V9.07219C7.4305 8.69625 7.52949 8.32593 7.72314 8.00362C7.9168 7.68131 8.19728 7.42003 8.5325 7.24969C8.72899 7.15461 8.89643 7.00865 9.01744 6.82698C9.13845 6.64531 9.20862 6.43455 9.22064 6.2166C9.23266 5.99864 9.18611 5.78144 9.08581 5.58756C8.98552 5.39368 8.83514 5.23019 8.6503 5.11408C8.46546 4.99796 8.25291 4.93345 8.03471 4.92725C7.81651 4.92106 7.60063 4.97339 7.4095 5.07883C7.21837 5.18427 7.05895 5.33895 6.94781 5.52683C6.83667 5.7147 6.77787 5.92891 6.7775 6.14719C6.7775 6.29638 6.71823 6.43945 6.61274 6.54494C6.50726 6.65043 6.36418 6.70969 6.215 6.70969C6.06581 6.70969 5.92274 6.65043 5.81725 6.54494C5.71176 6.43945 5.6525 6.29638 5.6525 6.14719C5.65375 5.80373 5.73012 5.46469 5.87624 5.15386C6.02237 4.84303 6.23472 4.56792 6.4984 4.34783C6.76208 4.12773 7.07072 3.96798 7.40267 3.87977C7.73461 3.79156 8.08184 3.77703 8.42 3.83719C8.89211 3.92601 9.32594 4.15664 9.66361 4.49834C10.0013 4.84004 10.2268 5.27656 10.31 5.74969C10.4046 6.25535 10.3294 6.7781 10.0961 7.23658C9.8628 7.69506 9.48447 8.06355 9.02 8.28469C8.87783 8.36211 8.75985 8.47735 8.6791 8.61766C8.59836 8.75796 8.558 8.91787 8.5625 9.07969V9.69469C8.56052 9.84257 8.50039 9.98373 8.39512 10.0876C8.28984 10.1915 8.14789 10.2497 8 10.2497Z'
                              fill='#838492'
                            />
                            <path
                              d='M7.99999 12.1924C8.31065 12.1924 8.56249 11.9405 8.56249 11.6299C8.56249 11.3192 8.31065 11.0674 7.99999 11.0674C7.68933 11.0674 7.43749 11.3192 7.43749 11.6299C7.43749 11.9405 7.68933 12.1924 7.99999 12.1924Z'
                              fill='#7950F2'
                            />
                          </svg>
                        </a>
                      </label>
                    </div>
                  </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-lg-5 pe-0'>
                  <div className='select-quantity'>
                    {noOfCredit <= 0 ? (
                      <div className='quantity-top'>
                        <span className='icon'>
                          <svg
                            width='61'
                            height='38'
                            viewBox='0 0 61 38'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M57.75 21.625C59.1307 21.625 60.25 20.5057 60.25 19.125C60.25 17.7443 59.1307 16.625 57.75 16.625V21.625ZM1.63848 17.3572C0.662172 18.3335 0.662172 19.9165 1.63848 20.8928L17.5484 36.8027C18.5247 37.779 20.1076 37.779 21.0839 36.8027C22.0602 35.8264 22.0602 34.2434 21.0839 33.2671L6.94178 19.125L21.0839 4.98286C22.0602 4.00655 22.0602 2.42364 21.0839 1.44733C20.1076 0.47102 18.5247 0.47102 17.5484 1.44733L1.63848 17.3572ZM57.75 16.625H3.40625V21.625H57.75V16.625Z'
                              fill='#7950F2'
                            />
                          </svg>
                        </span>
                        <h5>Select your quantity</h5>
                        <p>Use the slider or type how many message credits you want to send.</p>
                      </div>
                    ) : (
                      <>
                        {showContactInfo && (
                          <>
                            <div className='Notification-msg'>
                              <svg
                                width='17'
                                height='18'
                                viewBox='0 0 17 18'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle cx='8.5' cy='9' r='8.5' fill='#FDE5AC' />
                                <path d='M8.5 5.5V11' stroke='#FAC04C' stroke-linecap='round' />
                                <circle cx='8.5' cy='13' r='0.5' fill='#FAC04C' />
                              </svg>

                              <p>
                                Need better pricing? Contact your account manager or{' '}
                                <a href='mailto:info@cellcast.com.au'>info@cellcast.com.au</a>
                              </p>
                            </div>
                          </>
                        )}
                        <div>
                          <h5>Payment Summary</h5>
                          <div className='center-summary'>
                            <div className='d-flex justify-content-between mb-1'>
                              <p>Credit Type</p>
                              <span>{`${quickSms.toLocaleUpperCase()} Credit`}</span>
                            </div>
                            <div className='d-flex justify-content-between mb-1'>
                              <p>Amount</p>
                              <span>{handleNumberConvert(Math.ceil(noOfCredit))}</span>
                            </div>
                            <div className='d-flex justify-content-between mb-1'>
                              <p>Cost per Credit</p>
                              <span>
                                {discount === 0 && leastPrice > price && (
                                  <span
                                    className='fw-normal'
                                    style={{textDecoration: 'line-through', opacity: 0.5}}
                                  >
                                    {leastPrice}
                                  </span>
                                )}
                                {discount !== 0 && (
                                  <span style={{textDecoration: 'line-through', opacity: 0.5}}>
                                    {price}
                                  </span>
                                )}{' '}
                                {discount !== 0 ? +discountedPrice : unitPrice}
                              </span>
                            </div>
                            {couponCode && (
                              <div className='d-flex justify-content-between align-items-center mb-4'>
                                <div className='d-flex gap-2 align-items-center'>
                                  <p className='mb-0'>Coupon</p>
                                  <span className='badge bg-primary text-white rounded-3 text-xs'>
                                    {couponCode}
                                  </span>
                                </div>
                                <span>{getCouponValue()}</span>
                              </div>
                            )}
                          </div>

                          {handleCalculateDiscountPercentage(discount ?? discountPercentage) >
                            0 && (
                            <div className='alert' role='alert'>
                              <i className='bi bi-info-circle'></i>
                              <span>
                                You are saving $
                                {handleNumberConvert(
                                  handleCalculateDiscount(discount ?? discountPercentage).toFixed(0)
                                )}{' '}
                                (
                                {handleCalculateDiscountPercentage(
                                  discount ?? discountPercentage
                                ).toFixed(0)}
                                %)
                              </span>
                            </div>
                          )}

                          <hr className='my-4' />

                          <div className='bill-price'>
                            <div className='d-flex justify-content-between mb-1'>
                              <p>Sub Total</p>
                              <span className='fw-normal'>
                                ${handleNumberConvert(subTotal.toFixed(2))}
                              </span>
                            </div>
                            <div className='d-flex justify-content-between mb-1'>
                              <p>GST</p>
                              <span className='fw-normal'>
                                {handleNumberConvert((+subTotal * 0.1).toFixed(2))}
                              </span>
                            </div>
                            <div className='d-flex justify-content-between mb-1'>
                              <p>Discount</p>
                              <span className='fw-normal'>
                                ${handleNumberConvert(handleCalculateDiscount(discount).toFixed(0))}
                              </span>
                            </div>
                            {additionalFee?.amount !== 0 && (
                              <div className='d-flex justify-content-between mb-1'>
                                <p>Credit card transaction fee</p>
                                <span className='fw-normal'>
                                  {handleNumberConvert(additionalFee?.amount.toFixed(2))}
                                </span>
                              </div>
                            )}
                          </div>

                          <div className='billing-summary d-flex justify-content-between mt-2'>
                            <span>Billed Now</span>
                            <span>
                              $
                              {handleNumberConvert(
                                (+subTotal * 1.1 + (additionalFee?.amount ?? 0)).toFixed(2)
                              )}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                    <div className='quantity-bottom'>
                      <button
                        disabled={noOfCredit <= 0 || error !== ''}
                        className={`${noOfCredit <= 0 ? 'checkout-btn' : 'CreditButton'}`}
                        onClick={() => setCard(true)}
                      >
                        Checkout
                      </button>

                      {noOfCredit > 0 && !userDetail?.hasUsedCoupon && !error && (
                        <span className='coupon'>
                          Have a coupon code?{' '}
                          <a href='#' onClick={() => setPromocodePopup(true)}>
                            Add here
                          </a>
                        </span>
                      )}
                      <StripeJSProvider>
                        {({stripe}: any) =>
                          stripe ? (
                            <Elements stripe={stripe}>
                              <CardPaymentPopup
                                restData={() => restAllData()}
                                show={card}
                                popupOpen={false}
                                handleClose={() => {
                                  setCard(false)
                                  setDiscount(0)
                                  setFlatRate(0)
                                  setCheckBox(false)
                                  setCard(false)
                                  setCouponId('')
                                  setPrice(0)
                                  setNoOFCredit(0)
                                  setCouponCode('')
                                  setFreeCredit(0)
                                  setPercentage(0)
                                  handleClose()
                                }}
                                customData={{
                                  priceperItems: unitPrice,
                                  type: quickSms,
                                  credits: !checkBox
                                    ? +noOfCredit
                                    : Math.ceil(+noOfCredit + +noOfCredit * 0.3),
                                }}
                                couponId={couponId}
                                total={handleNumberConvert(
                                  (+subTotal * 1.1 + (additionalFee?.amount ?? 0)).toFixed(2)
                                )}
                              />
                            </Elements>
                          ) : null
                        }
                      </StripeJSProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default PurchasePopup
